module.exports = __webpack_public_path__ + "static/img/cybg_gg_1.91f3cb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cybg_gg_1.png
// module id = IT8L
// module chunks = 1